import { ICurrency, ICurrencyTransfer } from '../../types/currency';
import { ITransaction } from '../../types/transaction';
import {
  CLEAR_CURRENCY_TRANSFERS,
  GET_TRANSACTIONS_LIST,
  SET_CURRENCY_INFO,
  SET_CURRENCY_TRANSFERS,
} from './constants';

export const getTransactionsListAction = (list: ITransaction[], time: number) => ({
  type: GET_TRANSACTIONS_LIST,
  payload: { list, time },
});

export const setCurrencyInfoAction = (currency: ICurrency | null) => ({
  type: SET_CURRENCY_INFO,
  payload: { currency },
});

export const setCurrencyTransfersListAction = (list: ICurrencyTransfer[], time: number) => ({
  type: SET_CURRENCY_TRANSFERS,
  payload: { list, time },
});

export const clearCurrencyTransfersAction = () => ({
  type: CLEAR_CURRENCY_TRANSFERS,
  payload: {},
});
